<template>
  <q-layout view="hHh lpR fFf">
    <q-page-container>
      <q-page class="kaunt-page">
        <BootGate v-slot>
          <router-view />
        </BootGate>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<style lang="scss">
.kaunt-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

// Views that own their own internal scroll region (chat-style layouts) opt in
// to a viewport-bounded page so flex: 1; overflow: auto on a child actually
// has a height to overflow against. Without this, min-height: 100vh lets the
// page grow with content and the iframe document scrolls instead.
.kaunt-page--bounded {
  height: 100vh;
  min-height: 0;
}
</style>

<script setup lang="ts">
import BootGate from '@/components/BootGate.vue';
</script>
